import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns['hr']);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/hr.js';
require("flatpickr/dist/themes/airbnb.css");

import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';

import lozad from 'lozad';

import './js/components/gallery';
import './js/globals';
import './js/list';
import './js/details';
import './js/booking';
import './js/contact';
import './js/inquiry';
import './js/bookingAddGuests.js';
import './js/newsletter.js';
import './js/search-by-keyword';
import './js/analytics';

import './js/gutenberg/gutenberg.js';


window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/enterprise.js?render=6Lcund0sAAAAAEIOHzAuUX9qaowZ34zWpKAEnPxp");
    }
});
window.nobserver.observe();